export const frontmatter = {
    "draft": false,
    "title": "Contactos",
    "description": "Gestión de contactos y grupos de contacto en OnnIA.",
    "sidebar_label": "Descripción general",
    "sidebar_group": "referencia",
    "sidebar_order": 1
}

export const toc = []